import technologyBg from "@/assets/cc_img7_golf.png";

const experienceEngine = [
  "Seamless LED walls",
  "Spatial stadium audio",
  "Motion and ball tracking",
  "Environmental lighting",
  "Game-state triggers",
  "Stadium atmosphere effects",
];

const revenueEngine = [
  "Integrated ticketing and scheduling",
  "Video recording and replay capture",
  "Post-experience video sales",
  "User profiles and performance data",
  "Membership and leaderboard systems",
  "Team, league, and venue licensing opportunities",
];

function Group({ label, title, items }: { label: string; title: string; items: string[] }) {
  return (
    <div className="bg-background/30 backdrop-blur-[2px] border border-border/60 rounded-sm p-8">
      <div className="text-[10px] uppercase tracking-[0.35em] text-primary mb-2">{label}</div>
      <h3 className="font-display text-2xl mb-6">{title}</h3>
      <ul className="space-y-3">
        {items.map((t, i) => (
          <li key={t} className="flex items-start gap-4">
            <span className="font-display text-primary text-sm pt-1">{String(i + 1).padStart(2, "0")}</span>
            <span className="text-foreground/90 leading-relaxed">{t}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function Technology() {
  return (
    <section id="technology" className="relative py-32 bg-arena overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-0 bg-cover bg-center opacity-80 pointer-events-none"
        style={{ backgroundImage: `url(${technologyBg})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background/30 via-background/10 to-background/40 pointer-events-none" />
      <div className="relative mx-auto max-w-7xl px-6">
        <div className="max-w-3xl mb-16">
          <p className="text-xs uppercase tracking-[0.3em] text-primary mb-4">Technology</p>
          <h2 className="font-display text-4xl sm:text-6xl leading-tight">
            Powered by <span className="text-gradient-ember">seamless LED immersion.</span>
          </h2>
          <p className="mt-6 text-lg text-foreground/80 leading-relaxed">
            Every ClutchCube is a fully integrated experience stack combining cinema-grade
            hardware, real-time gameplay tracking, and a content engine purpose-built for the
            most pressurized moments in sports.
          </p>
        </div>
        <div className="grid lg:grid-cols-2 gap-6">
          <Group label="Group 01" title="Experience Engine" items={experienceEngine} />
          <Group label="Group 02" title="Revenue Engine" items={revenueEngine} />
        </div>
      </div>
    </section>
  );
}
